export enum LabelEnum {
    gallopBrushCO = 0,
    myCarWashGuy = 1,
    motorCityWashWork = 2,
    pecoCarWashSystem = 3,
    tommyCarWashSystems = 4,
    amvStockMitter = 5,
    misterCarWash = 6
}